(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fss-categories"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.fss-filter-chips').forEach(nav => {
  const selected = nav.querySelector('[aria-current="page"]');
  if (selected && nav.scrollWidth > nav.clientWidth) {
    const offset = selected.getBoundingClientRect().left - nav.getBoundingClientRect().left;
    nav.scrollLeft = Math.max(0, offset - (nav.clientWidth - selected.offsetWidth) / 2);
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fss-product-access"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fss-product-access')) {
  customElements.define('fss-product-access', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized || this.dataset.signedIn !== 'true') return;
      this.initialized = true;
      this.controller = new AbortController();
      this.onPageShow = event => { if (event.persisted) window.location.reload(); };
      window.addEventListener('pageshow', this.onPageShow);
      this.checkPurchases();
    }
    disconnectedCallback() {
      this.controller?.abort();
      window.removeEventListener('pageshow', this.onPageShow);
    }
    async checkPurchases() {
      const status = this.querySelector('[data-access-status]');
      const offer = this.querySelector('[data-purchase-offer]');
      status.textContent = this.dataset.checking;
      status.hidden = false;
      offer.hidden = true;
      const timeout = setTimeout(() => this.controller.abort(), 20000);
      try {
        const url = new URL(this.dataset.libraryUrl, window.location.origin);
        if (url.origin !== window.location.origin) throw new Error('Invalid library');
        let pages = 1;
        let ownsBundle = false;
        for (let page = 1; page <= pages; page++) {
          url.searchParams.set('page', String(page));
          const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: this.controller.signal });
          if (!response.ok) throw new Error('Purchase lookup failed');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const library = doc.querySelector('fss-library');
          if (!library || Number(library.dataset.page) !== page) throw new Error('Customer session unavailable');
          pages = Number(library.dataset.pages);
          if (!Number.isInteger(pages) || pages < 0 || pages > 1250) throw new Error('Invalid order pages');
          ownsBundle ||= library.dataset.bundle === 'true';
          if (ownsBundle) document.querySelectorAll('[data-bundle-upsell]').forEach(item => { item.hidden = true; });
          const row = [...library.querySelectorAll('[data-sound-id]')].find(item => item.dataset.soundId === this.dataset.productId);
          const link = row?.querySelector('[data-sound-download]');
          const isBundle = this.dataset.isBundle === 'true';
          if ((isBundle && ownsBundle) || (!isBundle && link)) {
            const button = this.querySelector('[data-owned-download]');
            if (isBundle) {
              button.href = this.dataset.libraryUrl;
            } else {
              const download = new URL(link.getAttribute('href'));
              if (download.protocol !== 'https:' || !['mediafire.com', 'www.mediafire.com'].includes(download.hostname)) throw new Error('Invalid download');
              button.href = download.href;
              button.removeAttribute('target');
            }
            this.querySelector('[data-owned-content]').hidden = false;
            status.hidden = true;
            this.dataset.access = 'owned';
            return;
          }
        }
        this.dataset.access = 'not-owned';
        offer.hidden = false;
        status.hidden = true;
      } catch (error) {
        this.dataset.access = 'unavailable';
        status.textContent = this.dataset.error;
        offer.hidden = false;
      } finally {
        clearTimeout(timeout);
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fss-search"] && !Shopify.designMode) return;
  try {
    document.addEventListener('formdata', (event) => {
  if (!event.target.matches('form[data-fss-title-search]')) return;
  const input = event.target.querySelector('[name="q"]');
  if (event.target.dataset.categoryQuery && input.value === input.defaultValue) {
    event.formData.set('q', event.target.dataset.categoryQuery); return;
  }
  const words = String(event.formData.get('q') || '').match(/[\p{L}\p{N}]+/gu) || [];
  event.formData.set('q', words.length ? words.map(word => `title:${word}*`).join(' AND ') : 'title:""');
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fss-waveform-loader"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('fss-waveform')) return;
  const jobs = [];
  const pending = new Map();
  const active = new Set();
  const barCount = 48;
  const byteLimit = 8 * 1024 * 1024;
  const cacheKey = 'fss-waveform-cache-v2';
  const cacheAge = 7 * 24 * 60 * 60 * 1000;
  const cacheLimit = 128;
  let scheduled = false;
  const valid = peaks => Array.isArray(peaks) && peaks.length === barCount && peaks.every(n => Number.isFinite(n) && n >= 2 && n <= 96);
  const cache = new Map();
  try {
    const saved = JSON.parse(localStorage.getItem(cacheKey));
    if (Array.isArray(saved)) saved.slice(-cacheLimit).forEach(entry => {
      if (!Array.isArray(entry)) return;
      const [url, value] = entry;
      if (typeof url === 'string' && value && Number.isFinite(value.at) && Date.now() - value.at >= 0 && Date.now() - value.at < cacheAge && valid(value.peaks)) cache.set(url, value);
    });
  } catch (_) {}
  const cached = url => {
    const value = cache.get(url);
    if (value && Date.now() - value.at < cacheAge) return value.peaks;
    try {
      const previous = JSON.parse(sessionStorage.getItem('fss-waveform-v1:' + url));
      if (valid(previous)) return previous;
    } catch (_) {}
  };
  const remember = (url, peaks) => {
    cache.delete(url); cache.set(url, { at: Date.now(), peaks });
    while (cache.size > cacheLimit) cache.delete(cache.keys().next().value);
    try { localStorage.setItem(cacheKey, JSON.stringify([...cache])); }
    catch (_) { try { sessionStorage.setItem('fss-waveform-v1:' + url, JSON.stringify(peaks)); } catch (_) {} }
  };
  const busy = () => !!document.querySelector('fss-audio[data-audio-priority]') || Array.from(document.querySelectorAll('fss-audio audio')).some(audio => !audio.paused);
  const schedule = () => {
    if (scheduled || active.size || busy() || !jobs.some(job => job.needed())) return;
    scheduled = true;
    const run = () => { scheduled = false; pump(); };
    if (window.requestIdleCallback) window.requestIdleCallback(run, { timeout: 1500 });
    else setTimeout(run, 150);
  };
  const pump = () => {
    if (busy() || active.size) return;
    const index = jobs.findIndex(job => job.needed());
    if (index < 0) return;
    const job = jobs.splice(index, 1)[0];
    job.interrupted = false;
    job.controller = new AbortController();
    active.add(job);
    analyse(job.url, job.controller).then(peaks => {
      if (job.controller.signal.aborted) throw new DOMException('Waveform interrupted', 'AbortError');
      remember(job.url, peaks); job.resolve(peaks);
    }).catch(error => {
      if (job.interrupted) jobs.unshift(job);
      else job.reject(error);
    }).finally(() => { active.delete(job); schedule(); });
  };
  const prioritize = () => {
    for (const job of active) {
      if (busy() || !job.needed()) { job.interrupted = true; job.controller.abort(); }
    }
    schedule();
  };
  document.addEventListener('fss-audio-priority', prioritize);
  ['play', 'pause', 'ended'].forEach(event => document.addEventListener(event, prioritize, true));
  const analyse = async (url, controller) => {
    const Context = window.OfflineAudioContext || window.webkitOfflineAudioContext;
    if (!Context) throw new Error('Waveform decoding unavailable');
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(url, { credentials: 'omit', signal: controller.signal, priority: 'low' });
      if (!response.ok || Number(response.headers.get('content-length')) > byteLimit) throw new Error('Preview unavailable or too large');
      const reader = response.body.getReader();
      const chunks = []; let length = 0;
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        length += value.length;
        if (length > byteLimit) { await reader.cancel(); throw new Error('Preview too large'); }
        chunks.push(value);
      }
      const bytes = new Uint8Array(length); let offset = 0;
      for (const chunk of chunks) { bytes.set(chunk, offset); offset += chunk.length; }
      const buffer = await new Context(1, 1, 8000).decodeAudioData(bytes.buffer);
      if (controller.signal.aborted) throw new DOMException('Waveform interrupted', 'AbortError');
      const channels = Array.from({ length: buffer.numberOfChannels }, (_, index) => buffer.getChannelData(index));
      const values = Array.from({ length: barCount }, (_, index) => {
        const start = Math.floor(index * buffer.length / barCount);
        const end = Math.max(start + 1, Math.floor((index + 1) * buffer.length / barCount));
        let energy = 0; let peak = 0; let samples = 0;
        for (const channel of channels) {
          for (let i = start; i < end && i < channel.length; i++) {
            const sample = Math.abs(channel[i]);
            energy += sample * sample; peak = Math.max(peak, sample); samples++;
          }
        }
        return samples ? Math.sqrt(energy / samples) * .7 + peak * .3 : 0;
      });
      const max = Math.max(...values, .00001);
      return values.map(value => Math.max(2, Math.round(96 * Math.pow(value / max, .7))));
    } finally { clearTimeout(timeout); }
  };
  const load = (url, waveform) => {
    const saved = cached(url);
    if (saved) return Promise.resolve(saved);
    if (!pending.has(url)) {
      const consumers = new Set();
      const promise = new Promise((resolve, reject) => {
        jobs.push({ url, resolve, reject, needed: () => [...consumers].some(wave => wave.isConnected && wave.visible) });
      });
      pending.set(url, { promise, consumers });
    }
    const entry = pending.get(url);
    entry.consumers.add(waveform);
    schedule();
    return entry.promise;
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      entry.target.visible = entry.isIntersecting;
      if (entry.isIntersecting) entry.target.load();
    });
    prioritize();
  }) : null;
  class FssWaveform extends HTMLElement {
    get sources() {
      const audio = this.closest('fss-audio')?.querySelector('audio');
      return [...new Set(Array.from(audio?.querySelectorAll('source') || [], source => source.src))];
    }
    draw(peaks) {
      this.querySelectorAll('i').forEach((bar, index) => bar.style.setProperty('--h', peaks[index] + '%'));
      this.dataset.waveformState = 'ready';
    }
    connectedCallback() {
      if (this.dataset.waveformState) return;
      const saved = this.sources.map(cached).find(valid);
      if (saved) { this.draw(saved); return; }
      if (navigator.connection?.saveData || ['slow-2g', '2g'].includes(navigator.connection?.effectiveType)) return;
      if (!observer) {
        this.closest('fss-audio')?.querySelector('button')?.addEventListener('click', () => { this.visible = true; this.load(); }, { once: true });
      } else { observer.observe(this); }
    }
    disconnectedCallback() { this.visible = false; observer?.unobserve(this); prioritize(); }
    async load() {
      if (this.dataset.waveformState) return;
      this.dataset.waveformState = 'loading';
      try {
        let peaks;
        for (const source of this.sources) {
          try { peaks = await load(source, this); break; } catch (_) {}
        }
        if (!valid(peaks)) throw new Error('No waveform');
        this.draw(peaks);
      } catch (_) { this.dataset.waveformState = 'unavailable'; }
    }
  }
  customElements.define('fss-waveform', FssWaveform);
})();
  } catch(e) { console.error(e); }
})();

})();
